import { Waves } from "lucide-react";
import { Link } from "wouter";

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-deep-navy text-white py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <Link href="/" className="flex items-center text-2xl font-playfair font-bold">
              <Waves className="w-8 h-8 mr-2" />
              South FL<span className="text-luxury-gold">Waterfront</span>
            </Link>
            <Link href="/" className="text-luxury-gold hover:text-yellow-300 transition-colors duration-200">
              Back to Home
            </Link>
          </div>
        </div>
      </header>

      {/* About Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-playfair font-bold text-deep-navy mb-8">About South FL Waterfront</h1>
        <p className="text-gray-600 mb-8">Last updated: September 2025</p>

        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <p>
            South FL Waterfront is a curated destination for exceptional waterfront real estate across Miami, Miami Beach, the Keys, Fort Lauderdale, and surrounding coastal communities. Our goal is simple: help you discover and tour the finest oceanfront, bayfront, and intracoastal homes with ease.
          </p>

          <h2 className="text-2xl font-bold text-deep-navy mt-8 mb-4">What We Do</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Aggregate and surface luxury waterfront listings with rich visuals.</li>
            <li>Offer fast, map-based search focused on real waterfront inventory.</li>
            <li>Connect serious buyers with experienced, licensed local agents.</li>
          </ul>

          <h2 className="text-2xl font-bold text-deep-navy mt-8 mb-4">Fair Housing Commitment</h2>
          <p>
            We comply fully with the Fair Housing Act and do not discriminate on the basis of race, color, religion, sex, handicap, familial status, or national origin. Equal Housing Opportunity.
          </p>

          <h2 className="text-2xl font-bold text-deep-navy mt-8 mb-4">How We Source Listings</h2>
          <p>
            Sample property data shown is for demonstration purposes only. In production, this site integrates with your IDX feed to display live MLS listings. All information is deemed reliable but not guaranteed and should be verified with the listing broker. We are not affiliated with any real estate brokerage or MLS.
          </p>

          <h2 className="text-2xl font-bold text-deep-navy mt-8 mb-4">Brokerage & Referrals</h2>
          <p>
            South FL Waterfront is a marketing platform. We are not a licensed brokerage. By submitting an inquiry, you agree that your information may be shared with licensed real estate agents or brokers for the purpose of scheduling tours or providing property information.
          </p>

          <h2 className="text-2xl font-bold text-deep-navy mt-8 mb-4">Contact</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Email: info@sellingsouthflwaterfront.com</li>
            <li>Location: Miami Beach, FL</li>
          </ul>

          <div className="mt-10 text-sm text-gray-600">
            <p>
              For more information on how we handle your data, please review our <Link href="/privacy-policy" className="text-ocean-blue hover:underline">Privacy Policy</Link>. Your use of this website is subject to our Terms of Use.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}


